import { Dispatch, ProviderProps, SetStateAction, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

const fakeConversationId = 'fakeConversationId';

export const isFakeConversation = (conversation: Conversation.Conversation) => {
  return conversation.conversationId === fakeConversationId;
};

export function createFakeConversation(
  partail?: Partial<Conversation.Conversation>,
): Conversation.Conversation {
  return {
    talkId: '',
    conversationId: fakeConversationId,
    buyerId: '',
    buyerNick: '',
    assistantId: '',
    storeId: '',
    processed: false,
    unreadCount: 0,
    pinned: false,
    lastReadMsgId: '',
    lastMsgId: '',
    lastExternalMsgId: '',
    lastMsgType: 'TEXT',
    lastMsgContent: '',
    lastMsgTime: '',
    lastMsgFromType: 'SYSTEM',
    yunXinTid: '',
    channel: 'SHOPEE',
    region: 'ID',
    asterisk: false,
    colorAsterisk: 'NO_STAR',
    botMark: false,
    controlStatus: false,
    guaranteedAssign: false,
    transferMark: false,
    superviseMark: false,
    supervisePower: false,
    receptionName: '',
    receptionId: '',
    blacklistFlag: false,
    canBeSent: false,
    isWaitAssign: false,
    tunnelAccountId: '0',
    externalBuyerId: '1',
    ...partail,
  };
}

export interface ReviewContextValue {
  conversation: Conversation.Conversation;
  profile: Review.Profile;
  setProfile: (profile: Review.Profile | null) => void;
  detail: Review.Detail;
  setDetail: Dispatch<SetStateAction<Review.Detail | undefined>>;
  refreshReview: () => Promise<void>;
  updateStatus: (status: Review.Status, quiet?: boolean) => Promise<void>;
  onConversationCreated: (conversation: Conversation.Conversation) => void;
}

export const ReviewContext = createNamedContext<ReviewContextValue | null>('ReviewContext', null);

export function useReviewContext() {
  const value = useContext(ReviewContext);

  if (value === null) {
    throw new Error(
      'useReviewContext hook should be use in a context of ReviewContextProvider component and the value of ReviewContextProvider should not be null.',
    );
  }

  return value;
}

export function ReviewContextProvider(props: ProviderProps<ReviewContextValue | null>) {
  return <ReviewContext.Provider {...props} />;
}
